import { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import API from '../../api'
import TripadvisorButton from './TripadvisorButton'
import ScubaTribeButton from './ScubaTribeButton'
import DiverRatingButton from './DiverRatingButton'
import TripadvisorRating from './TripadvisorRating'
import ScubaTribeRating from './ScubaTribeRating'
import DiverRating from './DiverRating'
import ReviewPopup from '../popups/ReviewPopup'
import get from 'lodash/get'
import setQuery from 'set-query-string'
import { parseQuery } from '../../utils'
export default class Reviews extends Component {
  constructor(props) {
    super(props)
    const queryParams = parseQuery()
    setQuery({ showRatingPopup: null })

    this.state = {
      reviews: null,
      openModal: queryParams && queryParams.showRatingPopup === 'show',
      reviewsArray: [],
      activeTab: props.scubaTribe ? 'scuba-tribe' : 'trip-advisor',
    }
  }

  componentDidMount() {
    this.getReviews()
  }

  getReviews(page = 1) {
    API(`shop/${this.props.slug}/reviews/`)
      .get({
        kind: 10,
        page: page,
        page_size: 3,
      })
      .then((reviews) => {
        const results = get(reviews, 'data.results', [])
        this.setState({
          reviews,
          reviewsArray: [...this.state.reviewsArray, ...results],
          activeTab:
            !this.props.scubaTribe && !this.props.tripAdvisor
              ? 'padi-rating'
              : this.state.activeTab,
        })
      })
  }

  setTab = (activeTab) => {
    this.setState({
      activeTab,
    })
  }

  triggerPopup = (openModal) => {
    this.setState({
      openModal,
    })
  }

  render() {
    let { reviews, reviewsArray, activeTab } = this.state
    const { scubaTribe, tripAdvisor, resortTripAdvisor, kind } = this.props
    // showRatingPopup === 'show'
    return (
      <div className='rating-container'>
        <ReviewPopup
          slug={this.props.slug}
          kind={this.props.kind}
          shopTitle={this.props.title}
          isOpen={this.state.openModal}
          closeModal={() => this.triggerPopup(false)}
        />
        <div className='rating-block wrapper'>
          <div className='rating-lft'>
            <h2 className='do-icon-title'>
              <i className='font-icons chat-icon' />
              <FormattedMessage id='reviews' defaultMessage='Reviews' />
            </h2>
            {(reviews && !reviews.reviewsPosted) || !reviews ? (
              <span className='add-review-btn'>
                <button
                  className='btn-outline'
                  onClick={() => this.triggerPopup(true)}
                >
                  <FormattedMessage
                    id='write_review'
                    defaultMessage='Write a review'
                  />
                </button>
              </span>
            ) : (
              ''
            )}
          </div>
          <div className='rating'>
            <div
              className={`tabs-wrap resort-rating ${
                !scubaTribe &&
                !tripAdvisor &&
                (!reviews || (reviews && !reviews.numberOfReviews))
                  ? 'no-reviews'
                  : ''
              }`}
            >
              <ul className='tabs-menu'>
                {scubaTribe ? (
                  <li
                    href='#reviews'
                    className={activeTab === 'scuba-tribe' ? 'active' : ''}
                    onClick={() => this.setTab('scuba-tribe')}
                  >
                    <ScubaTribeButton
                      rating={scubaTribe.rating}
                      url={scubaTribe.url}
                      numberOfReviews={scubaTribe.reviews_number}
                    />
                  </li>
                ) : (
                  ''
                )}
                {resortTripAdvisor && kind === 20 ? (
                  <li
                    className={
                      activeTab === 'resort-trip-advisor' ? 'active' : ''
                    }
                    onClick={() => this.setTab('resort-trip-advisor')}
                  >
                    <TripadvisorButton
                      title={
                        <FormattedMessage
                          id='tripadvisor_resort'
                          defaultMessage='TripAdvisor Resort rating'
                        />
                      }
                      rating={resortTripAdvisor.data.rating}
                      image={resortTripAdvisor.data.rating_image_url}
                      url={resortTripAdvisor.data.web_url}
                      numberOfReviews={resortTripAdvisor.data.numReviews}
                      alt={resortTripAdvisor.data.name}
                    />
                  </li>
                ) : (
                  ''
                )}
                {tripAdvisor && kind === 10 ? (
                  <li
                    className={activeTab === 'trip-advisor' ? 'active' : ''}
                    onClick={() => this.setTab('trip-advisor')}
                  >
                    <TripadvisorButton
                      rating={tripAdvisor.data.rating}
                      image={tripAdvisor.data.rating_image_url}
                      url={tripAdvisor.data.web_url}
                      numberOfReviews={tripAdvisor.data.numReviews}
                      alt={tripAdvisor.data.name}
                    />
                  </li>
                ) : (
                  ''
                )}
                {reviews && reviews.numberOfReviews ? (
                  <li
                    href='#reviews'
                    onClick={() => this.setTab('padi-rating')}
                    className={activeTab === 'padi-rating' ? 'active' : ''}
                  >
                    <DiverRatingButton
                      rating={reviews.averageVotes.rate}
                      numberOfReviews={reviews.numberOfReviews}
                    />
                  </li>
                ) : (
                  ''
                )}
              </ul>
              <div className='tabs-container-wrap'>
                {scubaTribe && activeTab === 'scuba-tribe' ? (
                  <ScubaTribeRating
                    url={scubaTribe.url}
                    reviews={scubaTribe.results.slice(0, 5)}
                  />
                ) : (
                  ''
                )}
                {resortTripAdvisor && activeTab === 'resort-trip-advisor' ? (
                  <TripadvisorRating
                    reviews={resortTripAdvisor.data.reviews}
                    url={resortTripAdvisor.data.web_url}
                    writeReviewUrl={resortTripAdvisor.data.write_review}
                  />
                ) : (
                  ''
                )}
                {tripAdvisor && activeTab === 'trip-advisor' ? (
                  <TripadvisorRating
                    reviews={tripAdvisor.data.reviews}
                    url={tripAdvisor.data.web_url}
                    writeReviewUrl={tripAdvisor.data.write_review}
                  />
                ) : (
                  ''
                )}
                {reviews && activeTab === 'padi-rating' ? (
                  <DiverRating
                    reviews={reviewsArray}
                    next={reviews.data.next}
                    kind={this.props.kind}
                    getMore={(page) => this.getReviews(page)}
                    averageVotes={reviews.averageVotes}
                  />
                ) : (
                  ''
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
